const isString=value=>"string"==typeof value;export{isString};